
import { Component, Vue } from "vue-property-decorator";
// import Pagina from "@/components/Pagina/Pagina.vue";
import Pagina from "@/components/Pagina/NewPagina.vue";
@Component({
  components: {
    Pagina
  }
})
export default class GenericoView extends Vue {}
